import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { useBridgeState } from '@digitaz/bridge-sdk-client';
import usePaymentStatusPostMessage from './usePaymentStatusPostMessage';
import { PaymentStatusMessageParams } from '../utils/helpers/paymentStatusMessage';
import {
  clearAzericardPaymentPending,
  enrichPaymentStatusParams,
  isAzericardPaymentStatus
} from '../utils/helpers/azericardPaymentStatus';
import {
  dispatchWebViewFailurePaymentStatus,
  dispatchWebViewSuccessPaymentStatus
} from '../utils/helpers/dispatchWebViewPaymentStatusModal';
import { finishPaymentSuccessNavigation } from '../utils/helpers/finishPaymentSuccessNavigation';

type OnPaymentStatusSuccess = (params: PaymentStatusMessageParams) => void;

export default function useWebViewPaymentStatusPostMessageHandler(
  onSuccess?: OnPaymentStatusSuccess
) {
  const dispatch = useDispatch();
  const { isWebView } = useBridgeState();

  usePaymentStatusPostMessage(
    useCallback(
      params => {
        const enrichedParams = enrichPaymentStatusParams(params);

        if (isAzericardPaymentStatus(enrichedParams)) {
          clearAzericardPaymentPending();

          if (isWebView) {
            if (enrichedParams.status === 'success') {
              dispatchWebViewSuccessPaymentStatus(dispatch, enrichedParams);
              onSuccess?.(enrichedParams);
            } else if (enrichedParams.status === 'failure') {
              const errorMessage =
                typeof enrichedParams.error_message === 'string'
                  ? enrichedParams.error_message
                  : null;
              dispatchWebViewFailurePaymentStatus(
                dispatch,
                'error',
                errorMessage
              );
            }

            return;
          }

          if (enrichedParams.status === 'success') {
            onSuccess?.(enrichedParams);
            finishPaymentSuccessNavigation();
          }

          return;
        }

        if (enrichedParams.status === 'success') {
          dispatchWebViewSuccessPaymentStatus(dispatch, enrichedParams);
          onSuccess?.(enrichedParams);
        } else if (enrichedParams.status === 'failure') {
          const errorMessage =
            typeof enrichedParams.error_message === 'string'
              ? enrichedParams.error_message
              : null;
          dispatchWebViewFailurePaymentStatus(dispatch, 'error', errorMessage);
        }
      },
      [dispatch, isWebView, onSuccess]
    )
  );
}
